// +----------------------------------------------------------------------
// | 热门纠结 / 匿名聚合（Phase 7）
// |
// | 这几个接口都**免登录**：公共数据，也是新用户进来「先看看别人纠结什么」的入口。
// | 后端只返回聚合数字，不含任何人的具体问题或个人信息。
// +----------------------------------------------------------------------
import request from '../lib/request';

/**
 * 热门纠结榜单
 * @param {{days?:number, fresh?:1}} params days 默认 30，上限 180
 * @returns {{days:number, window:{from:string,to:string}, sample:number, decided:number,
 *            categories:Array, topics:Array, threshold:object, policy:object, updated_at:string}}
 */
export function hotTopics(params) {
  return request.get('/topics/hot', { params });
}

/**
 * 某个话题（job-change）或某个分类（work）的匿名聚合
 * @param {string} key 话题 slug 或分类英文枚举
 * @param {{days?:number, fresh?:1}} params
 * @returns {{key:string, kind:'topic'|'category', label:string, emoji:string,
 *            category:string, category_label:string, sample:number, decided:number,
 *            satisfied:number, satisfied_percent:number|null, percent_available:boolean,
 *            options:Array<{name:string,count:number,percent:number|null}>, note:string}}
 */
export function topicStats(key, params) {
  return request.get(`/topics/${key}/stats`, { params });
}

/** 同上，早期调用层用的是 /aggregate 这个名字 */
export function topicAggregate(key, params) {
  return topicStats(key, params);
}

/** 话题 / 分类字典（前端本地补全用） */
export function topicLabels() {
  return request.get('/topics/labels');
}
